module.exports = __webpack_public_path__ + "images/raster/app/web/src/assets/crm-logo-35311649.png";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/crm-logo.png
// module id = ./app/web/src/assets/crm-logo.png
// module chunks = 0